// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__8oSP5","upgradeText":"Overlay_upgradeText__pgow7"};